import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviationMapPopupComponent } from './deviation-map-popup.component';
import { MaterialModule } from "../../material/material.module";



@NgModule({
  declarations: [
    DeviationMapPopupComponent
  ],
  imports: [
    CommonModule,
    MaterialModule
],
  exports:[
    DeviationMapPopupComponent
  ]
})
export class DeviationMapPopupModule { }
